import Repository from "./Repository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};

const signUp = "/marcom/admin/signup";
const login = "/marcom/admin/login";
const getModules = "/admin/modules/get";
const getRoles = "/uibuilder/getRoles";
const createNewPassword = "/marcom/admin/createNewPassword";
const getPlan = "/billing/scope/get";
// const GetImage = "/BrainstormUserSettingsApi/GetImages";

export default {
  userSignUp(payload) {
    return Repository.post(`${signUp}`, payload);
  },
  userLogin(payload) {
    return Repository.post(`${login}`, payload);
  },

  createNewPassword(payload) {
    return Repository.post(`${createNewPassword}`, payload);
  },

  getModules(payload) {
    return Repository.post(`${getModules}`, payload);
  },

  getRoles(payload) {
    return Repository.post(`${getRoles}`, payload);
  },

  getPlan(payload) {
    return Repository.post(`${getPlan}`, payload);
  },
};
